import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05a0a825"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msg-item jc-right" }
const _hoisted_2 = {
  key: 0,
  class: "status"
}
const _hoisted_3 = {
  key: 1,
  class: "icon-close"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_small_loader = _resolveComponent("app-small-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "my",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resendMessage && _ctx.resendMessage(...args)))
    }, [
      (_ctx.msg.status === _ctx.MOCK_MESSAGE_STATUS.SENDING)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_app_small_loader, {
              "white-spinner": "",
              size: 10
            })
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3)),
      _createElementVNode("p", null, _toDisplayString(_ctx.msg.text), 1)
    ])
  ]))
}